export default __webpack_public_path__ + "static/media/3.580e33ed.jpg";